import * as Support from './Support';

export default {
  Support,
};
